// src/App.js
import React, { useState, createContext, useEffect } from 'react';
import Routing from './routing/Routing';
import { useSelector, useDispatch } from 'react-redux';
import { Toast } from './components/_index';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TicketDataProvider } from './context/TicketContext';
import { AuthProvider } from './context/AuthProvider';
import { PermissionProvider } from './context/PermissionProvider';
import { requestNotificationPermission } from './utils/requestNotificationPermission';
import { useFirebaseMessaging } from './utils/hooks/useFirebaseMessaging';
import { useNotificationPermissionCheck } from './utils/hooks/useNotificationPermissionCheck';
import { notificationAudio } from './utils/audio';
import { Dialog, Box, Typography, Button } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
  typography: {
    fontFamily: "'Inter', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*, *::before, *::after": {
          fontFamily: "'Inter', sans-serif !important",
        },
      },
    },
  },
});

export const ThemeContext = createContext()


function App() {

  const Secret_Key = "I AM SECRET ONE"

  // Check notification permissions on every page load/refresh
  const { showNotificationModal, closeModal } = useNotificationPermissionCheck();

  useEffect(() => {
    requestNotificationPermission();

    // Unlock audio context on first user interaction
    const unlockAudio = () => {
      notificationAudio.volume = 0; // Silent
      notificationAudio.play().then(() => {
        console.log("Audio unlocked");
        notificationAudio.pause();
        notificationAudio.currentTime = 0;
        notificationAudio.volume = 1; // Restore volume
        document.removeEventListener("click", unlockAudio);
        document.removeEventListener("keydown", unlockAudio);
      }).catch((err) => console.log("Audio unlock failed", err));
    };

    document.addEventListener("click", unlockAudio);
    document.addEventListener("keydown", unlockAudio);

    return () => {
      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("keydown", unlockAudio);
    };
  }, []);

  useFirebaseMessaging();

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
      <CssBaseline />
      <ThemeContext.Provider value={{ Secret_Key }}>
        <TicketDataProvider>
          <AuthProvider>
            <PermissionProvider>
              <Toast />
              <ToastContainer
                position="bottom-center"
                autoClose={5000}
                closeOnClick={false}
                pauseOnHover
                draggable={false}
                theme="light"
                style={{ zIndex: 9999 }}
              />
              <Routing />

          {/* Notification Permission Modal - Shows on refresh if denied */}
          <Dialog
            open={showNotificationModal}
            onClose={closeModal}
            aria-labelledby="notification-alert-title"
            aria-describedby="notification-alert-description"
          >
            <Box sx={{ p: 3, maxWidth: 400 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, fontFamily: 'Open Sans, sans-serif' }}>
                Notifications Blocked
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, color: '#263A43', fontFamily: 'Open Sans, sans-serif' }}>
                We strongly recommend enabling notifications to stay updated.
              </Typography>
              <Typography variant="body2" sx={{ mb: 3, color: '#263A43', fontFamily: 'Open Sans, sans-serif', fontWeight: 600 }}>
                To enable: Click the 🔒 lock / 🔽 filter / ℹ️ info icon in your address bar &gt; Site Settings &gt; Notifications &gt; Allow.
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  onClick={closeModal}
                  variant="contained"
                  sx={{
                    backgroundColor: '#00675D',
                    color: 'white',
                    '&:hover': { backgroundColor: '#00554d' },
                    textTransform: 'none'
                  }}
                >
                  OK, I understand
                </Button>
              </Box>
            </Box>
          </Dialog>
            </PermissionProvider>
          </AuthProvider>
        </TicketDataProvider>
      </ThemeContext.Provider>
      </ThemeProvider>
    </React.Fragment>

  );
}

export default App;
